import recipeList from "./recipeList";
import nutritionalSpecList from "./nutritionalSpecList";
import fftList from "./fftList";
import auth from "./auth";
import message from "./message";
import site from "./site";
import loading from "./loading";

export default {
 recipeList,
 nutritionalSpecList,
 fftList,
 loading,
 // old modules without namespacing
 auth,
 message,
 site,
};
